const VALID_RATINGS = new Set(['positive', 'negative', 'concern'])

/** Feedback state for an actuals row (positive / negative / concern / none). */
export function actualsFeedbackState(item) {
  if (!item || item._overlap_group_header)
    return null
  const feedback = item.actual && item.actual.feedback
  if (feedback == null || String(feedback).trim() === '')
    return 'none'
  const normalized = String(feedback).trim().toLowerCase()
  if (VALID_RATINGS.has(normalized))
    return normalized
  return 'none'
}

export function matchesActualsFeedbackFilter(item, selectedFeedback) {
  if (!selectedFeedback)
    return true
  if (item && item._overlap_group_header)
    return false
  return actualsFeedbackState(item) === selectedFeedback
}

export function countActualsFeedback(items, state) {
  return (items || []).filter(item => actualsFeedbackState(item) === state).length
}

/** Locate the canonical row in items_full for a feedback event item. */
export function findActualsFeedbackRow(items, item, isTbn = false) {
  if (!item || !items || !items.length)
    return null
  if (isTbn)
    return items.find(row => row && row.ID === item.ID) || null
  return items.find(row =>
    row
    && row.bookingID === item.bookingID
    && row.movementID === item.movementID,
  ) || null
}

/** Hover help for feedback filter chips on the Actuals page. */
export const ACTUALS_FEEDBACK_FILTER_TOOLTIPS = {
  group: 'Filter the table by team feedback on processed actuals. Counts reflect the current date range and status filters (before the feedback filter is applied).',
  positive: 'Show actuals marked as correct or acceptable. Click the chip to filter; click again to clear.',
  negative: 'Show actuals marked as incorrect or not usable. Click the chip to filter; click again to clear.',
  concern: 'Show actuals flagged with a concern and optional comment. Click the chip to filter; click again to clear.',
  none: 'Show actuals with no feedback yet. Click the chip to filter; click again to clear.',
  clear: 'Remove all feedback ratings and comments for every actual in the current date range.',
}
